<template>
  Help
</template>

<script>
export default {
  name: 'Help'
}
</script>
